import { render, staticRenderFns } from "./CardDownload.vue?vue&type=template&id=e77522a2&scoped=true"
import script from "./CardDownload.vue?vue&type=script&lang=js"
export * from "./CardDownload.vue?vue&type=script&lang=js"
import style0 from "./CardDownload.vue?vue&type=style&index=0&id=e77522a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77522a2",
  null
  
)

export default component.exports